import { render, staticRenderFns } from "./ReportePromediosCantidad.vue?vue&type=template&id=304ca8fe&scoped=true"
import script from "./ReportePromediosCantidad.vue?vue&type=script&lang=js"
export * from "./ReportePromediosCantidad.vue?vue&type=script&lang=js"
import style0 from "./ReportePromediosCantidad.vue?vue&type=style&index=0&id=304ca8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ca8fe",
  null
  
)

export default component.exports